
import DropdownNormal from '~/components/Molecules/DropdownNormal/DropdownNormal.vue'

export default {
  name: 'DropdownNormalContent',

  components: {
    DropdownNormal,
  },

  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getDescription(tab) {
      if (typeof tab.featuredIntro === 'string') {
        return tab.featuredIntro
      }

      return JSON.stringify(tab.featuredIntro || '')
    },
  },
}
